import { Ban, Bot, RotateCcw } from "lucide-react";
import {
  BatchActionBar,
  BatchActionButton,
} from "@/components/batch-action-bar";
import { ProviderIcon } from "@/components/workflow/workflow-rail";
import type { TriageAction } from "@/components/experience/triage-action-dialog";

interface WorkspaceBatchBarProps {
  selectedCount: number;
  selectedCanonicalIds: string[];
  isTrackerConfigured: boolean;
  activeProvider: string | null;
  isPending: boolean;
  onClear: () => void;
  onOpenBulkIssues: () => void;
  onOpenActionDialog: (action: TriageAction) => void;
  onBulkReopen: () => void;
  onBulkDispatch?: () => void;
}

export function WorkspaceBatchBar({
  selectedCount,
  selectedCanonicalIds,
  isTrackerConfigured,
  activeProvider,
  isPending,
  onClear,
  onOpenBulkIssues,
  onOpenActionDialog,
  onBulkReopen,
  onBulkDispatch,
}: WorkspaceBatchBarProps) {
  if (selectedCount === 0) return null;

  return (
    <BatchActionBar count={selectedCount} noun="finding" onClear={onClear}>
      {selectedCanonicalIds.length > 0 && isTrackerConfigured && (
        <BatchActionButton onClick={onOpenBulkIssues} disabled={isPending}>
          <ProviderIcon
            provider={activeProvider || undefined}
            className="mr-1.5 size-3.5"
          />
          Create issues ({selectedCanonicalIds.length})…
        </BatchActionButton>
      )}
      {selectedCanonicalIds.length > 0 && onBulkDispatch && (
        <BatchActionButton onClick={onBulkDispatch} disabled={isPending}>
          <Bot className="mr-1.5 size-3.5" />
          Queue fixes for agent ({selectedCanonicalIds.length})
        </BatchActionButton>
      )}
      <BatchActionButton
        onClick={() => onOpenActionDialog("dismiss")}
        disabled={isPending}
      >
        <Ban className="mr-1.5 h-3.5 w-3.5" />
        Dismiss…
      </BatchActionButton>
      <BatchActionButton onClick={onBulkReopen} disabled={isPending}>
        <RotateCcw className="mr-1.5 h-3.5 w-3.5" />
        Re-open
      </BatchActionButton>
    </BatchActionBar>
  );
}
